import { useCallback } from 'react'
import { useAppSelector } from '../../store/hooks'
import { buildImageUrl, IMAGE_PRESETS } from '@frontend/core/lib/modules/images'
import { ImageUrlOptions } from '@frontend/core/lib/modules/images/types'

/**
 * Hook to generate image URLs from static asset API
 * @returns Function to build image URLs with consistent caching
 */
export const useImageUrl = () => {
  const { urls } = useAppSelector((state) => state.servers)

  return useCallback(
    (
      imagePath?: string | null,
      preset: ImageUrlOptions = IMAGE_PRESETS.playerLarge
    ) => {
      if (!imagePath) return ''
      const staticAssetApiUrl = urls.staticAssetApi?.url
      if (!staticAssetApiUrl) return ''
      return buildImageUrl(staticAssetApiUrl, imagePath, preset)
    },
    [urls.staticAssetApi?.url]
  )
}
